import axios from "axios";
import url from "@/utils/api/url";

const URL_COMMON = url.URL_API + '/common';

// 与文件上传相关的URL
const URL_COMMON_UPLOAD = URL_COMMON + '/upload';

// 与附件文件信息相关的URL
const URL_COMMON_ATT_FILE = URL_COMMON + '/attFile';

// 与消息相关的URL
const URL_COMMON_MESSAGE = URL_COMMON + '/message';
const URL_COMMON_MESSAGE_STATE = URL_COMMON + '/message/state';

export default {
    file: {
        uploadFile(file, type) {
            let form = new FormData();
            form.append('file', file);

            return axios({
                url: URL_COMMON_UPLOAD,
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data;charset=UTF-8'
                },
                params: {
                    type: type
                },
                data: form
            });
        },
    },
    attFile: {
        getAttFileData(ownerId, attFileCategory) {
            return axios.get(URL_COMMON_ATT_FILE, {params: {ownerId, attFileCategory}});
        },
        getAttFileInfoById(attFileId) {
            return axios.get(URL_COMMON_ATT_FILE + '/' + attFileId);
        },
        insertAttFileInfo(info) {
            return axios.post(URL_COMMON_ATT_FILE, info);
        },
        deleteAttFileInfoById(attFileId) {
            return axios.delete(URL_COMMON_ATT_FILE + '/' + attFileId);
        },
    },
    message: {
        getMessageDataWithPaging(filterCondition) {
            return axios.get(URL_COMMON_MESSAGE, {params: filterCondition});
        },
        getMessageInfo(messageId) {
            return axios.get(URL_COMMON_MESSAGE + '/' + messageId);
        },
        insertMessageInfo(info) {
            return axios.post(URL_COMMON_MESSAGE, info);
        },
        updateMessageState(info) {
            return axios.put(URL_COMMON_MESSAGE_STATE + '/' + info.messageId, info);
        },
    },
}